import { FC } from 'react'
import { LinkProps, useNavigate } from 'react-router-dom'

import { cn } from 'src/lib/cn'
import LaunchingSquareIcon from '../Icons/LaunchingSquareIcon'

export type LaunchingLinkProps = LinkProps

const LaunchingLink: FC<LinkProps> = ({
  to,
  onClick,
  className,
  target = '_blank',
  ...linkProps
}) => {
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent<HTMLSpanElement | HTMLAnchorElement>) => {
    e.stopPropagation()
    e.preventDefault()
    onClick?.(e as React.MouseEvent<HTMLAnchorElement>)
    if (target === '_blank') {
      window.open(to as string, '_blank')
      return
    }
    navigate(to as string)
  }

  return (
    <span
      data-testid="launching-link"
      className={cn('flex text-inherit decoration-0! outline-none hover:text-black', className)}
      onClick={handleClick}
      {...linkProps}
    >
      <LaunchingSquareIcon width={undefined} height={undefined} className="size-4" />
    </span>
  )
}

export default LaunchingLink
